<template>
  <div class="box">
    <div>{{ msg }}</div>
  </div>
</template>

<script>
import { doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";

export default {
  data() {
    return {};
  },

  mounted() {},
  methods: {},
};
</script>

<style scoped>
@import "../../assets/css/goods832";
</style>



// WEBPACK FOOTER //
// src/components/page/goods832.vue